import styled from 'styled-components';
import {
  Popover,
} from 'antd';
import {
  COLOR_CV_6,
  COLOR_CV_5,
  COLOR_WHITE,
} from 'constants/colors';

interface TypeColor extends Record<string, string> {
  background: string,
  backgroundHover: string,
  border: string,
  borderHover: string,
  color: string,
  colorHover: string,
}

type PopoverColorType = 'primary' | 'default' | 'ghost' | 'text' | 'dashed' | 'link';

const TypeColors: Record<PopoverColorType, TypeColor> = {
  primary: {
    background: COLOR_CV_6,
    backgroundHover: COLOR_CV_5,
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_WHITE,
    colorHover: COLOR_WHITE,
  },
  default: {
    background: 'transparent',
    backgroundHover: 'transparent',
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_CV_6,
    colorHover: COLOR_CV_5,
  },
  ghost: {
    background: 'transparent',
    backgroundHover: 'transparent',
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_CV_6,
    colorHover: COLOR_CV_5,
  },
  dashed: {
    background: 'transparent',
    backgroundHover: 'transparent',
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_CV_6,
    colorHover: COLOR_CV_5,
  },
  text: {
    background: 'transparent',
    backgroundHover: 'transparent',
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_CV_6,
    colorHover: COLOR_CV_5,
  },
  link: {
    background: COLOR_CV_6,
    backgroundHover: COLOR_CV_5,
    border: COLOR_CV_5,
    borderHover: COLOR_CV_5,
    color: COLOR_WHITE,
    colorHover: COLOR_WHITE,
  },
};

const getColorForType = (
  prop: 'background' | 'backgroundHover' | 'border' | 'borderHover' | 'color' | 'colorHover',
  type?: PopoverColorType,
) => TypeColors[type || 'primary'][prop];

// export const StyledAntdPopover = styled(Popover)`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: auto;

//   &, &:active, &:focus {
//     background-color: ${() => getColorForType('background')};
//     color: ${() => getColorForType('colorHover')};
//   }

//   &:hover {
//     background-color: ${() => getColorForType('backgroundHover')};
//     color: ${() => getColorForType('color')};
//     border-color: ${() => getColorForType('borderHover')};
//   }

//   &:active, &:focus {
//     border-color: ${() => getColorForType('border')};
//   }
// `;

export const StyledAntdPopover = styled(Popover)`
`;
